import React from 'react';
import { SGSCard } from 'components/SGSCard';
import { Box, Container, Grid, GridSize } from '@material-ui/core';

type CardProps = React.HTMLAttributes<HTMLFormElement> & {
    shadow?: boolean;
    maxWidth?: any;
};

const Card: React.FC<CardProps> = ({ children, shadow = true, maxWidth = 'md', ...props }) => (
    <Container maxWidth={maxWidth}>
        <SGSCard className="p-2" shadow={shadow}>
            <form {...props}>{children}</form>
        </SGSCard>
    </Container>
);

/**
 * Représente une ligne dans un formulaire, les inputs doivent FORCÉMENT être situés dans un composant Col
 */
const Row: React.FC = ({ children }) => (
    <Grid container spacing={2}>
        {children}
    </Grid>
);

type ColProps = {
    md?: GridSize;
};

const Col: React.FC<ColProps> = ({ children, md = 12 }) => (
    <Grid item xs={12} md={md}>
        <Stack>{children}</Stack>
    </Grid>
);

const Stack: React.FC = ({ children }) => (
    <>
        {React.Children.map(children, (c) => (
            <Box display="flex" mb={2} flexDirection="column">
                {c}
            </Box>
        ))}
    </>
);

const Actions: React.FC = ({ children }) => (
    <Box mt={4} display="flex" justifyContent="flex-end">
        {children}
    </Box>
);

const SGSForm = {
    Card,
    Row,
    Col,
    Actions,
    Stack,
};

export default SGSForm;
